



































import { Vue, Component } from 'vue-property-decorator'
import { Button } from 'mand-mobile'
import store from '@/store'

@Component({ components: { [Button.name]: Button } })
export default class Result extends Vue {
  countDownTimer: any = null
  curCount: number = 1
  count: number = 3

  get isSuccess() {
    if (this.$route.query.result === 'SUCCESS') {
      return true
    } else {
      return false
    }
  }
  get score() {
    if (this.$route.query.result === 'SUCCESS') {
      return this.$route.query.score
    } else {
      return ''
    }
  }
  get message() {
    if (this.$route.query.result === 'IAM_FAILED') {
      return this.$t(`result.tokenExpired`)
    } else {
      return this.$route.query.message
    }
  }
  get returnUrl() {
    return this.$route.query.returnUrl
  }
  restartHandler() {
    this.$router.push({ name: 'imageHome', query: {
      biz_token: store.bizToken,
      failedReturnUrl: store.failedReturnUrl,
    }})
  }
  nextStep() {
    window.location.href = `${this.returnUrl}?successCode=${this.$route.query.result}&version=image`
  }
  countDownPromise() {
    this.resetCountDown()
    this.countDownTimer = setInterval(() => {
      this.curCount --
      if (this.curCount <= 1) {
        clearInterval(this.countDownTimer)
        this.nextStep()
      }
    }, 1000)
  }
  resetCountDown() {
    this.curCount = this.count
    clearInterval(this.countDownTimer)
    this.countDownTimer = null
  }
  async mounted() {
    // console.log('language', navigator.language)
    if (this.$route.query.result === 'SUCCESS' && this.returnUrl) {
      this.countDownPromise()
    }
  }
}
